import { type OutgoingHttpHeaders } from 'node:http';

import { defaultPlacementMiddleware } from '../default-placement-middleware';
import { type PlacementMiddlewareContexts } from '../types';

export const customHeadersMiddleware =
	(headers: Record<keyof OutgoingHttpHeaders, string>) =>
	async ({ request, koa }: PlacementMiddlewareContexts) => {
		const isCustomHeadersEnabled = request.statsig.checkGate(
			{ identifiers: { atlassianAccountId: request.orchestrationContext.recipient.userId } },
			'post-office-custom-headers-v2',
		);

		if (isCustomHeadersEnabled) {
			koa.ctx.set(headers);
		}

		return defaultPlacementMiddleware;
	};
